<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="wrapper" v-if="!gonglixiao">
          <el-row>
            <el-col :span="4">
              <div class="footer_left">
                <div class="footer_left_img">
                  <el-image class="qr_img" :src="homepage.footer_wx_img_url" fit="fill"></el-image>
                  <br />{{ homepage.footer_wx_title }}
                </div>
              </div>
            </el-col>
            <el-col :span="20">
              <div class="footer_right">
                <div class="footer_right_1">
                  <span style="font-weight: bold">校区地址:</span>
                  {{ homepage.footer_contact_address }}
                </div>
                <div class="footer_right_2">
                  <span style="font-weight: bold">联系我们:</span>
                  {{ homepage.footer_contact_tel }}
                </div>
                <div class="footer_right_3">
                  <span style="font-weight: bold"></span>
                  {{ homepage.footer_contact_wechat }}
                </div>

                <div class="footer_right_4">
                  <el-row>
                    <el-col :span="10">
                      <div>
                        <ul>
                          <i style="margin-right: 10px; font-weight: bold">社区须知:</i>
                          <i style="margin-right: 10px">关于我们</i>
                          <i style="margin-right: 10px">用户协议</i>
                          <i style="margin-right: 10px">社区守则</i>
                          <i style="margin-right: 10px">网络测评</i>
                          <i style="margin-right: 10px">意见反馈</i>
                        </ul>
                      </div>
                    </el-col>
                  </el-row>
                </div>

                <div class="footer_right_5" v-if="homepage.is_show_copy_right">
                  <span>Copyright © STEAM.FUN 2021. All Rights Reserved</span>

                  <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010302002038" target="_blank"
                    style="
                      display: inline-block;
                      font-size: 10px;
                      font-weight: normal;
                      color: #666;
                      margin-left: 20px;
                    ">
                    <img style="width: 10px; height: 10px"
                      src="https://wuge-homepage-resourse.oss-cn-beijing.aliyuncs.com/img/beian.png" />
                    津公网安备 12010302002038号</a>

                  <a href="https://beian.miit.gov.cn/" target="_blank" style="
                      display: inline-block;
                      font-size: 10px;
                      font-weight: normal;
                      color: #666;
                      margin-left: 20px;
                    ">
                    津ICP备17004637号-4</a>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getHomepage } from "@/api/homeset";
export default {
  name: "community-footer",

  data() {
    return {
      homepage: {}, //footer数据
      BlackList: ["hgedu","zhiyu"],
      gonglixiao: false,
    };
  },

  mounted() {
    console.log("获取学校信息");
    this.getHomepage();
  },

  methods: {
    getHomepage() {
      getHomepage().then((res) => {
        console.log("FOOTER校区首页");
        console.log(res);
        if (res.homepageData) {
          console.log("有校区信息");
          this.homepage = res.homepageData.homepage;

          for (let i = 0; i < this.BlackList.length; i++) {
            if (res.schoolInfo.domain == this.BlackList[i]) {
              this.gonglixiao = true;
              console.log("这个学校是公立校1");
            }
          }
        } else {
          console.log("无校区信息");
          this.$message.warning("无校区信息");
        }
      });
    },

    GotoClassroom(cmd) {
      console.log("进入教室");

      if (cmd == "1") {
        this.$router.push({
          name: "classroomIndexStu",
        });
      } else {
        this.$router.push({
          name: "classroomIndex",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  color: #666;
  font-weight: bold;

  background: #eff3f5;
  padding: 20px;

  .footer_left {
    height: 200px;
    display: flex;
    flex-flow: column;

    .footer_left_img {
      flex: 1;
      text-align: center;
      padding-top: 50px;

      .qr_img {
        width: 100px;
        height: 100px;
      }
    }
  }

  .footer_right {
    height: 200px;
    display: flex;
    flex-flow: column;

    .footer_right_1 {
      flex: 1;
      line-height: 40px;
    }

    .footer_right_2 {
      flex: 1;
      line-height: 40px;
    }

    .footer_right_3 {
      flex: 1;
      line-height: 40px;
    }

    .footer_right_4 {
      flex: 1;
      line-height: 40px;
    }

    .footer_right_5 {
      flex: 1;
      line-height: 40px;
    }
  }
}
</style>
